import moment from 'moment';

export const formatDate = (data) => {
  try {
    const splitData = data.split('-');
    return `${splitData[2]}/${splitData[1]}/${splitData[0]}`;
  } catch (err) {
    return data;
  }
};

export const formatDate2 = (data) => {
  try {
    const splitData = data.split('/');
    return `${splitData[2]}-${splitData[1]}-${splitData[0]}`;
  } catch (err) {
    return data;
  }
};

export const formatMoney = (money) => {
  if (money <= 0) {
    return `R$ 0`;
  }

  return `R$${money.toFixed(2)}`;
};

export const getTipoTributacao = (razao_social, cpf) => {
  const rs = razao_social.split(' ');
  if (rs[rs.length - 1] === cpf) {
    return 1;
  }
  return 2;
};

export const isEmailValid = (email) => {
  if (email && email.includes('@') && email.includes('.')) {
    return true;
  }

  return false;
};

export const isCepValid = (cep) => cep.replace(/\D/g, '').length === 8;

export const isCnpjValid = (cnpj) => cnpj.replace(/\D/g, '').length === 14;

export const isEmpty = (campo) => !campo;

export const Sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const onlyNumbers = (data) => (data ? data.replace(/\D/g, '') : null);

export const onlyNumbersDotCromma = (data) => data.replace(/[^0-9.|,]/g, '');

export const convertToCent = (data) => {
  const qtd = data.replace(',', '.').indexOf('.') + 2;
  return onlyNumbers(data).padEnd(qtd, '0');
};

export const getYears = (start) => {
  const years = [];
  while (start <= moment().year()) {
    years.push({ nome: start.toString(), valor: start });
    start += 1;
  }

  return years;
};

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

export const replaceSpecialChars = (str) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z_0-9- ]/g, '-') // Substitui caracteres especiais por hífen
    .replace(/-+/g, '-') // Substitui multiplos hífens por um único hífen
    .replace(/(^-+|-+$)/, ''); // Remove hífens extras do final ou do inicio da string
};

export const alphaNumerico = (str) => str.replace(/[^a-z0-9]/gi, '');
